import React, { useState } from "react";
import SiteWrapper from "../../SiteWrapper.react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { TablePageable } from "../../Helpers";
import {
  columnas,
  validarRango,
  consultarRecuperaciones,
  exportarRecuperacionesExcel,
  mensajeError,
} from "./reporteRecuperacionesGps.utils";

const ReporteRecuperacionesGps = () => {
  const [fechaInicio, setFechaInicio] = useState(moment().subtract(1, "days").format("YYYY-MM-DD"));
  const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
  const [recuperaciones, setRecuperaciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [consultado, setConsultado] = useState(false);

  const consultar = async () => {
    const error = validarRango(fechaInicio, fechaFin);
    if (error) {
      NotificationManager.warning(error, "Reporte de recuperaciones");
      return;
    }
    setCargando(true);
    try {
      const data = await consultarRecuperaciones(fechaInicio, fechaFin);
      setRecuperaciones(data);
      setConsultado(true);
      if (data.length === 0) {
        NotificationManager.info("No hay recuperaciones en el rango seleccionado", "Reporte de recuperaciones");
      }
    } catch (err) {
      NotificationManager.error(mensajeError(err), "Reporte de recuperaciones");
      console.log(err);
    } finally {
      setCargando(false);
    }
  };

  const exportarExcel = () => {
    if (recuperaciones.length === 0) {
      NotificationManager.info("No hay datos para exportar", "Reporte de recuperaciones");
      return;
    }
    exportarRecuperacionesExcel(recuperaciones, fechaInicio, fechaFin);
  };

  return (
    <SiteWrapper>
      <div className="container-fluid p-1">
        <hr color="white" />
        <div className="row mt-5">
          <div className="col-12">
            <TablePageable
              titulo={
                <div className="row">
                  <div className="col-3">
                    <label>Fecha inicio</label>
                    <input
                      className="form-control"
                      type="date"
                      value={fechaInicio}
                      max={fechaFin}
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    <label>Fecha fin</label>
                    <input
                      className="form-control"
                      type="date"
                      value={fechaFin}
                      min={fechaInicio}
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </div>
                  <div className="col-6 d-flex align-items-end">
                    <button className="btn btn-primary mr-2" onClick={consultar} disabled={cargando}>
                      {cargando ? "Consultando..." : "Consultar"}
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={exportarExcel}
                      disabled={cargando || recuperaciones.length === 0}
                    >
                      <i className="fa fa-file-excel-o" /> Exportar Excel
                    </button>
                    {consultado && (
                      <span className="ml-3">
                        <b>{recuperaciones.length}</b> recuperaciones
                      </span>
                    )}
                  </div>
                </div>
              }
              lista={recuperaciones}
              columnas={columnas}
              id="idGpsLog"
              paginacion={true}
              elementosPorPagina={50}
            />
          </div>
        </div>
      </div>
    </SiteWrapper>
  );
};

export default ReporteRecuperacionesGps;
